import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { SlotController } from '../../controllers/slot-controller';
import { AllowedHeadingLevels } from '../se-heading/config';
import componentStyles from './se-subscribe-box.css.lit';
import '../../base/outline-icon/outline-icon';
import '../se-button/se-button';
import '../se-container/se-container';
import '../se-heading/se-heading';
import { classMap } from 'lit/directives/class-map.js';

/**
 * The SeSubscribeBox component
 * @element subscribe-box
 */
@customElement('subscribe-box')
export class SeSubscribeBox extends OutlineElement {
  slots = new SlotController(this, true);
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String })
  heading: string;
  @property({ type: String, attribute: 'heading-level' })
  headingLevel: AllowedHeadingLevels = 'h2';
  @property({ type: String })
  link: string;
  @property({ type: String, attribute: 'link-text' })
  linkText: string;
  @property({ type: String })
  description: string;
  @property({ type: Boolean })
  inline: boolean;

  subscribeBoxImage(): TemplateResult {
    if (this.querySelector('[slot="subscribe-box-image"]')) {
      return html` <div class="subscribe-box__image">
        <slot name="subscribe-box-image"></slot>
      </div>`;
    } else {
      return html``;
    }
  }

  subscribeBoxContent(): TemplateResult {
    return html`
      <se-container>
        <div class="subscribe-box__content">
          <se-heading
            level="${this.headingLevel}"
            level-style="medium"
            level-size=${this.inline ? '3xl' : this.headingLevel}
            >${this.heading}</se-heading
          >
          ${this.subscribeBoxCta()}
          <div class="description">${unsafeHTML(this.description)}</div>
        </div>
      </se-container>
    `;
  }

  subscribeBoxCta() {
    if (this.linkText && this.link) {
      return html` <se-button
        button-size="medium"
        button-url="${this.link}"
        variant="${this.inline ? 'tertiary' : 'primary'}"
      >
        <outline-icon
          slot="right"
          size="1em"
          name="arrow-right"
          library="system"
          color="brand-secondary-1"
        ></outline-icon>
        ${this.linkText}</se-button
      >`;
    } else {
      return null;
    }
  }

  render(): TemplateResult {
    const classes = classMap({
      'subscribe-box': true,
      'subscribe-box--inline': this.inline,
    });
    return html` <div class="${classes}">
      ${this.subscribeBoxImage()} ${this.subscribeBoxContent()}
    </div>`;
  }
}
